import FlexBox from '@/atomic-components/FlexBox';
import { LencoImage } from '@/atomic-components/Image';
import { ICartItem } from '@/services/cart/models/cart';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';
import CartItemSummary from '../VerticalCart/CartItem/CartItemSummary';
import DeleteIcon from '@/assets/DeleteIcon.svg';

type TCartItemProps = {
	item: ICartItem;
	onDeleteClicked?: (item: ICartItem) => void;
	onUpdateItemQuantity?: (
		item: ICartItem,
		targetQuantity: number
	) => Promise<any>;
	Actions: React.ReactElement;
	Footer?: React.ReactElement;
	onItemClicked?: () => void;
	isDrawer?: boolean;
};

const CartItem = (props: TCartItemProps) => {
	const { item } = props;

	function canShowDeleteButton() {
		return props.onDeleteClicked && typeof props.onDeleteClicked == 'function';
	}

	function deleteIconClicked(e: any) {
		e.preventDefault();
		props.onDeleteClicked && props.onDeleteClicked(item);
	}

	return (
		<Box>
			<FlexBox
				p='24px 32px'
				alignItems={'center'}
				justifyContent={'space-between'}
				width='100%'
			>
				<FlexBox
					className='cursor-pointer'
					onClick={() => {
						props.onItemClicked && props.onItemClicked();
					}}
					width='100%'
					justifyContent='space-between'
				>
					<Box
						className='cart-item-image'
						width='113px'
						mr='16px'
						sx={{ minWidth: '113px' }}
					>
						<LencoImage aspectRatio={113 / 77} url={item.product.image} />
					</Box>
					<FlexBox
						direction='column'
						justifyContent='space-between'
						width='100%'
					>
						<CartItemSummary item={item} isDrawer={props.isDrawer} />
						{props.Actions}
					</FlexBox>
				</FlexBox>
				{canShowDeleteButton() && (
					<IconButton
						className='cart-item-delete-button'
						onClick={deleteIconClicked}
					>
						<DeleteIcon />
					</IconButton>
				)}
			</FlexBox>
			{props.Footer}
		</Box>
	);
};

export default CartItem;
